import { create } from 'zustand'

interface UIStoreState {
  terminalMode: boolean
  toggleTerminalMode: () => void
}

export const useUIStore = create<UIStoreState>((set) => ({
  terminalMode: false,
  toggleTerminalMode: () => set(state => ({ terminalMode: !state.terminalMode })),
}))
